import template from './privilege-list.html';

export default class PrivilegeListComponent {
  constructor() {
    this.template = template;
    this.bindings = {
      privilege: '<',
      privilegeKey: '<',
      parents: '<',
      root: '<',
      toggleAction: '&',
      isEditable: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/components/privilege-list/privilege-list-component.js